// Map 에서 Data 관련 공통적으로 사용할 수 있는 함수
const mapData = {
    getGeolocationError(code) {
        let errorDesc = '';

        switch (code) {
            case 0: errorDesc = '알 수 없는 오류'; break;
            case 1: errorDesc = '위치 서비스 권한 없음'; break;
            case 2: errorDesc = '위치 사용 불가'; break;
            case 3: errorDesc = 'Time Out'; break;
        }

        return errorDesc;
    },
    getConvertDateToElapsed(str) {
        const year   = parseInt(str.slice(0, 4));
        const month  = parseInt(str.slice(4, 6));
        const day    = parseInt(str.slice(6, 8));
        const hour   = parseInt(str.slice(8, 10));
        const minute = parseInt(str.slice(10, 12));
        const second = parseInt(str.slice(12, 14));

        const date = new Date(year, month - 1, day, hour, minute, second);
        const now = new Date();

        const diffInMilliseconds = now - date;

        const convertMsToTime = (ms) => {
            const days = Math.floor(ms / (24 * 60 * 60 * 1000));
            const hours = Math.floor((ms % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000));
            const minutes = Math.floor((ms % (60 * 60 * 1000)) / (60 * 1000));
            return { days, hours, minutes };
        };

        const { days, hours, minutes } = convertMsToTime(diffInMilliseconds);

        let text = '';

        if (days > 29) {
            text = '30일 이상';
        } else {
            if (days > 0) {
                text = `${days}일 전`;
            } else {
                if (hours > 0) { text += `${hours}시간 `; }
                if (minutes > 0) { text += `${minutes}분 `; }
                text += ' 전';
            }
        }

        return text;
    },



    getChargerBackground(val) {
        let style = '';

        if (val === '1' || val === 1) {
            style = 'charger-status-box-possible';
        } else if (val === '2' || val === 2) {
            style = 'charger-status-box-ing';
        } else if (val === '3' || val === 3) {
            style = 'charger-status-box-broken';
        } else {
            style = 'charger-status-unable';
        }

        return style;
    },

    getChargerImageSrc(item, type) {
        let src = '';
        const chargerType = item.chgerType;

        if (type === 'combo') {
            if (chargerType === '04' || chargerType === '05' || chargerType === '06'|| chargerType == '08') {
                src = require(`@/assets/images/map/charger/dc-combo-on.png`);
            } else {
                src = require(`@/assets/images/map/charger/dc-combo-off.png`);
            }
        } else if (type === 'chademo') {
            if (chargerType === '01' || chargerType === '03' || chargerType === '05' || chargerType === '06') {
                src = require(`@/assets/images/map/charger/dc-chademo-on.png`);
            } else {
                src = require(`@/assets/images/map/charger/dc-chademo-off.png`);
            }
        } else if (type === 'ac3') {
            if (chargerType === '03' || chargerType === '06' || chargerType === '07') {
                src = require(`@/assets/images/map/charger/ac3-on.png`);
            } else {
                src = require(`@/assets/images/map/charger/ac3-off.png`);
            }
        } else if (type === 'ac') {
            if (chargerType === '02') {
                src = require(`@/assets/images/map/charger/ac-on.png`);
            } else {
                src = require(`@/assets/images/map/charger/ac-off.png`);
            }
        }

        return src;
    },
    getDateFormatString(str) {
        let dateStr = '-';

        if (str !== null && str !== '') {
            let year = str.substr(0, 4);
            let month = str.substr(4, 2);
            let day = str.substr(6, 2);
            let hour = str.substr(8, 2);
            let minute = str.substr(10, 2);
            let second = str.substr(12, 2);

            dateStr = year+'-'+month+'-'+day+' '+hour+':'+minute+':'+second;
        }

        return dateStr;
    },


    getChargerType(agency, item) {
        let chargerType = '';

        if (agency == '1') {
            // 환경부
            switch (item.chgerType) {
                case '01': chargerType = 'DC'; break;
                case '02': chargerType = 'AC'; break;
                case '03': chargerType = 'DC'; break;
                case '04': chargerType = 'DC'; break;
                case '05': chargerType = 'DC'; break;
                case '06': chargerType = 'DC'; break;
                case '07': chargerType = 'DC'; break;
            }
        } else if (agency == '2') {
            // 한국전력
            if (item.chargeTp != '' || item.chargeTp != null) {
                chargerType = item.chargeTp == '2' ? 'DC' : 'AC';
            } else {
                switch (item.cpTp) {
                    case '1': chargerType = 'AC'; break;
                    case '2': chargerType = 'AC'; break;
                    case '3': chargerType = 'AC'; break;
                    case '4': chargerType = 'AC'; break;
                    case '5': chargerType = 'DC'; break;
                    case '6': chargerType = 'AC'; break;
                    case '7': chargerType = 'DC'; break;
                    case '8': chargerType = 'DC'; break;
                    case '9': chargerType = 'DC'; break;
                    case '10': chargerType = 'DC'; break;
                }
            }
        }

        return chargerType;
    },
    getChargerName(agency, type, item) {
        let chargerName = '-';

        if (agency == '1') {
            // 환경부
            switch (type) {
                case 'DC': chargerName = '급속 ' + item.chgerId; break;
                case 'AC': chargerName = '완속 ' + item.chgerId; break;
            }
        } else if (agency == '2') {
            // 한국전력
            chargerName = item.cpNm;
        }

        return chargerName;
    },
    getChargerOutput(agency, type, item) {
        let output = '-';

        if (agency == '1') {
            if (item.output == null || item.output == '' || item.output == 'null') {
                output = type == 'DC' ? '50 kW' : '7 kW';
            } else {
                output = item.output + ' kW';
            }
        } else if (agency == '2') {
            output = type == 'DC' ? '50 kW' : '7 kW';
        }

        return output;
    },

    /*getChargerBackground(item) {
        let color = '';

        if (item == 'possible') {
            color = '#5598f1';
        } else if (item == 'ing') {
            color = '#ff7f00';
        } else {
            color = '#bababa';
        }

        return color;
    },*/

    getChargerStatusTitle(item) {
        switch (item) {
            case 'possible': return '충전 가능';
            case 'ing': return '충전중';
            case 'broken': return '고장/점검';
        }
    },
}

export default {
    install(Vue) {
        Vue.prototype.$_map_data = mapData
    }
}
